import React, { useEffect, useRef } from 'react';
import { useInView, useMotionValue, useSpring } from 'framer-motion';
interface AnimatedCounterProps {
  value: number;
  direction?: 'up' | 'down';
  className?: string;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}
export function AnimatedCounter({
  value,
  direction = 'up',
  className = '',
  prefix = '',
  suffix = '',
  decimals = 0
}: AnimatedCounterProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const motionValue = useMotionValue(direction === 'down' ? value : 0);
  const springValue = useSpring(motionValue, {
    damping: 60,
    stiffness: 100
  });
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (isInView) {
      motionValue.set(direction === 'down' ? 0 : value);
    }
  }, [isInView, value, direction, motionValue]);
  useEffect(() => {
    springValue.on('change', latest => {
      if (ref.current) {
        ref.current.textContent = `${prefix}${latest.toFixed(decimals)}${suffix}`;
      }
    });
  }, [springValue, decimals, prefix, suffix]);
  return <span ref={ref} className={className} data-id="element-1360" />;
}